import {StageService} from '../stage.service';
import {Injectable} from '@angular/core';

declare let THREE: any;

@Injectable()
export class SceneBoxCalculatorService {
  constructor(
    private stage: StageService
  ) {
  }

  calculate() {

    const parentFloor = this.stage.getCompoundFloor();
    const points = parentFloor.children
      .filter(ch => ch.name === 'floor')
      .map(ch => ch.userData.points.map(p => new THREE.Vector3(p.x, 0, p.y)))
      .reduce((result, item) => result.concat(item), []);

    const stairs = this.stage.getStairs();
    stairs.forEach(stair => {
      const firstP = stair.userData.firstOutPoint.clone();
      points.push(firstP);
      const secondP = stair.userData.secondOutPoint.clone();
      points.push(secondP);
    });
    return new THREE.Box3().setFromPoints(points);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/sceneBoxCalculator.service.ts